import React from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ImpersonationBanner = ({ impersonatedUser, onExit }) => {
  if (!impersonatedUser) return null;

  return (
    <Box sx={{ position: "sticky", top: 0, width: "100%" }}>
      <Alert
        severity="warning"
        icon={<VisibilityIcon fontSize="small" />}
        action={
          <Button color="inherit" size="small" variant="outlined" onClick={onExit}>
            Encerrar
          </Button>
        }
        sx={{ borderRadius: 0, py: 0.5 }}
      >
        <Typography variant="body2">
          Você está visualizando o sistema como <strong>{impersonatedUser.name}</strong>
        </Typography>
      </Alert>
    </Box>
  );
};

export default ImpersonationBanner;
